<template>
  <div id="app">
    <!-- <vue-drawer-layout
      ref="drawer"
      :drawer-width="250"
      :enable="isEnable"
      :animatable="true"
      :z-index="0"
      :drawable-distance="Math.floor(800/3)"
      :content-drawable="true"
      :backdrop="true"
      :backdrop-opacity-range="[0,0.7]"
      @mask-click="handleMaskClick"
    >-->

    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '100%' }"
      transition
    >
      <div class="drawer-nav-bar">
        <div class="nav-left">
          <img
            class="header-logo"
            src="./assets/lib/images/nav-logo.png"
            alt=""
          />
          <div class="nav-header-title">
            <p class="nav-top">中国音协管乐学会</p>
            <p class="nav-botom">低音铜管专业委员会</p>
          </div>
        </div>
        <img
          class="header-ico"
          @click="show = false"
          src="./assets/lib/images/navclose.png"
          alt=""
        />
      </div>
      <div class="drawer-content">
        <div class="drawer-content-head">
          <div class="drawer-content-head-title">中国管弦网</div>
          <div class="drawer-content-head-title">为您提供以下资讯和服务</div>
        </div>
        <div class="drawer-content-count">
          <div class="drawer-content-count-title">移动版</div>
          <ul class="drawer-content-table" @click="navclick">
            <li class="table-cell">
              <router-link to="/home">网站首页</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/publicity">关于我们</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/news">音乐资讯</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/province">各地省站</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/provinceNews">省站资讯</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/activity">活动报名</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/band">乐队天地</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/experts">专家学者</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/star">星光灿烂</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/teacherList">师资库</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/musicscore">乐谱汇</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/knowledge">知识汇</router-link>
            </li>
            <li class="table-cell">
              <router-link to="/appreciation">音乐欣赏</router-link>
            </li>
          </ul>
          <div class="drawer-content-count-title">服务</div>
          <ul class="drawer-content-table" @click="navclick">
            <li class="table-cell" @click="study">
              <router-link to="/news">在线学习</router-link>
              <!-- <span>在线学习</span> -->
            </li>
            <li class="table-cell" @click="musicServe">
              <router-link to="/home">乐器修修</router-link>
              <!-- <span>在线学习</span> -->
            </li>
            <li class="table-cell">
              <router-link to="/recruitList">人才招募</router-link>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>

    <div slot="content" class="viewcontent">
      <router-view
        v-if="$route.meta.normal != null && !$route.meta.normal"
      ></router-view>
      <div v-else class="body-container">
        <!-- 占位 -->
        <section class="placeholder" id="header-nav"></section>
        <header class="app-nav-bar" v-show="this.isShowHeaderFooter">
          <div class="nav-left" @click="homeclick">
            <img
              class="header-logo"
              src="./assets/lib/images/nav-logo.png"
              alt=""
            />
            <div class="nav-header-title">
              <p class="nav-top">中国音协管乐学会</p>
              <p class="nav-botom">低音铜管专业委员会</p>
            </div>
          </div>
          <img
            class="header-ico"
            @click="show = true"
            src="./assets/lib/images/nav-ico.png"
            alt=""
          />
        </header>
        <header class="app-nav-barbg" v-show="this.isHomeHeader">
          <div class="nav-left">
            <img
              class="header-logo"
              src="./assets/lib/images/navlogo.png"
              alt=""
            />
            <div class="nav-header-navtitle">
              <p class="nav-top bgcolor">中国音协管乐学会</p>
              <p class="nav-botom bgcolor">低音铜管专业委员会</p>
            </div>
          </div>
          <!-- @click="showOffcanvasHandle" -->
          <img
            class="header-ico"
            @click="show = true"
            src="./assets/lib/images/navclass.png"
            alt=""
          />
        </header>
        <!-- 内容 -->
        <!-- 需要被缓存的路由入口 -->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!-- 不需要被缓存的路由入口 -->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- <keep-alive>
            <transition name="el-fade-in">
              <router-view></router-view>
            </transition>
        </keep-alive>-->
        <!-- 底部 -->
        <footer v-show="this.isShowHeaderFooter" class="footer">
          <div class="banquan-warrp">
            Copyright © 2019 管弦网. All Rights Reserved. <br />苏19036667号-3 |
            版权所有：江苏管韵文化产业有限责任公司
          </div>
        </footer>
      </div>
    </div>

    <!-- </vue-drawer-layout> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _local } from "./common/js/localstorage";
import Button from "vant/lib/button";
import "vant/lib/button/style";
export default {
  name: "App",
  components: {},
  computed: {
    ...mapState(["isEnable", "loading"]),
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isShowHeaderFooter: false,
      screenWidth: document.body.clientWidth,
      isShowGoTop: false,
      oldUrl: "",
      isHomeHeader: false,
      drawer: false,
      show: false,
      isRouterAlive: true,
    };
  },
  created() {
    this.isShowStar();
    //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store") ) {
    //     this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    // }

    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload",()=>{
    //     sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    // })
  },
  mounted() {
    this.getScreenWidth();
    window.addEventListener("scroll", this.scrollToTop, true);
    // this.isShowOffcanvas();
  },
  updated() {},
  methods: {
    // 返回首页的点击
    homeclick() {
      this.$nextTick(() => {
        this.$router.push("/home");
      });
    },
    // 隐藏 底部侧滑  防止点击相同路由的变化
    navclick() {
      this.show = false;
    },
    // 跳转个人中心
    goVideoUserHandle() {
      window.location.href =
        "https://www.cnorch.com/mv/#/routerpage?backUrl=/user";
      // window.location.href ='http://192.168.43.54:8080/#/routerpage?backUrl=/user'
    },
    // 乐器修修
    musicServe() {
      window.location.href = "https://www.cnorch.com/propaganda/repair/show";
    },
    //在线学习
    study() {
      window.location.href = "https://www.cnorch.com/mv";
      // window.location.href ='http://192.168.3.50:8080/mv'
    },
    // 判断是否是星光灿烂的3级页面
    isShowStar() {
      var index = this.$route.path.split("/")[2];
      let navlength = this.$route.path.split("/")[1].length;
      this.isHomeHeader = false;
      if (index == "stardetail") {
        this.isShowHeaderFooter = false;
      } else if (index == "home" || navlength == 0) {
        this.isShowHeaderFooter = false;
        this.isHomeHeader = true;
      } else {
        this.isShowHeaderFooter = true;
      }
    },
    // 获取屏幕的宽
    getScreenWidth() {
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          this.screenWidth = window.screenWidth;
          const html = document.querySelector("html");
          if (this.screenWidth < 375) {
            html.style.fonSize = "16px";
          } else if (window.innerWidth < 768) {
            html.style.fontSize = `${(16 * window.innerWidth) / 375}px`;
          } else {
            html.style.fontSize = "32.768px";
          }
        })();
      };
    },

    handleMaskClick() {
      this.$refs.drawer.toggle(false);
    },
    showOffcanvasHandle() {
      this.$refs.drawer.toggle(true);
    },

    scrollToTop() {
      var container = document.querySelector(".viewcontent");
      if (container == null) {
        return;
      }

      var scrollTop = container.scrollTop;
      console.log(scrollTop, "scrollview上下滚动的距离------");
      if (scrollTop == 0) {
        this.isShowGoTop = false;
        this.$store.commit("isShowGoTopHandle", this.isShowGoTop);
      } else {
        if (!this.isShowGoTop) {
          this.isShowGoTop = true;
          this.$store.commit("isShowGoTopHandle", this.isShowGoTop);
        }
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  watch: {
    // 监听url的变化
    $route: function (newValue, oldValue) {
      console.log(newValue, oldValue);
      var newlevel = newValue.path.split("/").length - 1;
      var oldlevel = oldValue.path.split("/").length - 1;
      let navlength = newlevel.length;
      let isShowHeaderFooter = false;
      let isHomeHeader = false;
      if (newValue.path.split("/")[2] == "stardetail") {
        //  console.log("这是星光详情页")
        isShowHeaderFooter = false;
      } else {
        isShowHeaderFooter = true;
      }
      if (newValue.path.split("/")[1] == "home") {
        isShowHeaderFooter = false;
        isHomeHeader = true;
      }
      this.isShowHeaderFooter = isShowHeaderFooter;
      this.isHomeHeader = isHomeHeader;
      if (newValue.path != oldValue.path) {
        // 关闭侧滑
        // this.$refs.drawer.toggle(false);
        // 跳转页面到顶部
        var headerNav = document.getElementById("header-nav");
        if (headerNav != null) {
          headerNav.scrollIntoView();
        }
      }
      this.show = false;
      // 如果是从首页跳转至星光详情页
      // if(oldValue.path.split('/')[1] == 'home' && newValue.path.split('/')[2] == 'stardetail'){
      //   this.oldUrl = oldValue.path
      //   _local.set('oldUrl',this.oldUrl,1000*60*60)
      // }
      /**
       * local首页
       * 跳转星光中转页startransit
       *  startransit中转页判断
       * 没有登录信息----》跳转微信登录页 ----》跳回startransit----》再判断----》 startransit --- 》有登录信息 ----》跳转详情页
       * startransit --- 》有登录信息 ----》跳转详情页
       * 点击返回，如果跳转的是 startransit，强制回到local首页
       */

      // 星光列表页跳转到星光详情页

      /***
       * local当前页
       * 跳转星光详情页
       * 没有登录信息----》跳转微信登录页 ----》跳转详情页
       * 有登录信息，获取数据
       * 返回
       * 有登录信息正常返回
       * 如果跳转的是微信页，判断有无登录信息，有就跳转local当前页
       *
       */
    },
  },
};
</script>

<style>
body,
html {
  font-family: "微软雅黑";
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
}
.drawer-content {
  background: #fff;
}
.drawer-content-head {
  margin: 0px 15px;
  padding: 30px 0px;
  border-bottom: 1px solid #c8c8c8;
}
.drawer-content-head-title {
  color: #666;
  font-size: 14px;
  text-align: center;
  line-height: 25px;
}
.drawer-content-count {
  margin: 0px 15px;
  background: #fff;
  padding: 30px 0px;
}
.drawer-content-count-title {
  color: #333;
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 15px;
}
.drawer-content-table {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.drawer-content-table .table-cell:nth-child(3n) {
  margin-right: 0px;
}
.table-cell {
  width: 32%;
  height: 35px;
  background: #f0f0f0;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  text-align: center;
  margin-right: 2%;
  line-height: 35px;
  margin-bottom: 15px;
}
.table-cell a {
  font-size: 14px;
  color: #333;
}
li {
  list-style: none;
}
/* h2,h3,h4,h5,h6,em {
    font-weight: 100;
    font-style: normal
} */
i {
  font-style: normal;
}
.viewcontent {
  position: relative;
  background-color: #fff;
  height: 100%;
  width: 100%;
  overflow: scroll;
  z-index: 1;
}
.body-container {
  width: 100%;
  /* height: 100%; */
}
#app {
  height: 100vh;
  /* height: 100%; */
}

.mui-table-view {
  background-color: #fff !important;
}
.mui-table-view-cell {
  height: 47px;
  padding: 14px 15px !important;
}
.mui-table-view-cell > a {
  font-family: "黑体";
  font-size: 18px;
  color: #333;
}
.user-center {
  font-family: "黑体";
  font-size: 18px;
  color: #333;
}
.app-nav-barbg {
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background: url("./assets/lib/images/navbg.jpg") #fff 0% 0% / contain
    no-repeat;
  background-size: 100% auto;
}
.app-nav-bar {
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.drawer-nav-bar {
  background-color: #f0f0f0;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 10px;
}
.nav-left {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-logo {
  width: 85px;
  height: 30px;
}
.nav-header-title {
  width: 95px;
  height: 30px;
  font-size: 10px;
  margin-left: 7px;
  position: relative;
}
.nav-header-navtitle {
  width: 95px;
  height: 30px;
  font-size: 10px;
  margin-left: 7px;
  position: relative;
}
.nav-header-navtitle::before {
  content: "|";
  color: #fff;
  position: absolute;
  left: -3px;
  top: 5px;
  font-size: 15px;
}
.nav-header-title::before {
  content: "|";
  color: #999;
  position: absolute;
  left: -3px;
  top: 5px;
  font-size: 15px;
}
.nav-top {
  color: black;
  font-size: 10px;
  height: 12px;
  font-weight: bold;
  font-family: "黑体";
  margin: 0;
  text-align: center;
}
.nav-botom {
  font-size: 9px;
  text-align: center;
  height: 15px;
  color: #999;
  font-family: "黑体";
  margin: 0;
}
.bgcolor {
  color: #fff;
}
.header-ico {
  width: 26px;
}
#header-nav {
  height: 0;
}
.mask {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.4);
  box-shadow: -4px 0 4px rgba(0, 0, 0, 0.5), 4px 0 4px rgba(0, 0, 0, 0.5);
}
.mask-active {
  display: block;
}
.placeholder {
  height: 50px;
  width: 100%;
}
.banquan-warrp {
  background: #110746;
  text-align: center;
  padding: 20px 0;
  color: #7877a9;
  font-size: 12px;
}
.drawer-wrap {
  background: #f1f1f1;
}
.placeholder {
  height: 82px;
  width: 100%;
}
/* .footer{
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 900;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue